import { useEffect } from 'react'

// useEffect with debounce
const useDebounce = (fn, delay, deps = []) => {
  useEffect(
    () => {
      const timer = setTimeout(fn, delay)
      return () => clearTimeout(timer)
    },
    // eslint-disable-next-line
    deps
  )
}
export default useDebounce
